// Single source of truth for the brand mark in the React app.
//
// The logo is referenced by URL rather than imported as a module so that all three
// surfaces resolve the same file: server.js mounts frontend/src/assets/images at
// /images, views/partials/brandLogo.hbs points there, and the transactional emails
// point at the same path on the public host. Importing it instead would emit a
// second copy into frontend/dist/images via webpack's asset/resource rule, leaving
// two files to keep in step. css-loader is configured to leave root-relative urls
// alone (see webpack.config.js), so this path survives the build untouched.
//
// When Design delivers the vector version, drop it into frontend/src/assets/images
// and change the filename here and in brandLogo.hbs.
export const BRAND_LOGO_SRC = "/images/crosscope-logo-2026.png";
export const BRAND_NAME = "CrosscopeDx by Clarapath";
